import { createRootRoute, Outlet } from "@tanstack/react-router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"

import { NotFound } from "../sections/errors/NotFound"

export const Route = createRootRoute({
  notFoundComponent: () => <NotFound />,
  component: RootRoute,
})

function RootRoute() {
  return (
    <>
      <Outlet />

      <TanStackRouterDevtools />
    </>
  )
}
